goog.provide('el8.uiwidget.addDatepicker');

goog.require('el8.util.datecompare');
goog.require('el8.util.consts');
goog.require('el8.uiwidget.alert');


/**
 * This is a wrapper around the the jQuery UI datepicker
 * that does some standard configuration of it.
 *
 * We mostly use it via the Form widget in _initField.
 * If a field spec has a datePickerOpts key, the Form
 * will call el8.uiwidget.addDatepicker.
 *
 * Note there's also a $.el8_datePicker wrapper around
 * the same jQuery UI widget (in uiwidget.js).
 * That's legacy code that should be migrated to use this file.
 */
el8.uiwidget.addDatepicker = function(infoField, opts) {

    opts = opts || {};

    var dateSelectedFn = opts.dateSelectedFn || null;
    var closeFn = opts.closeFn || null;
    var defaultDate = opts.defaultDate || null;
    var $input = infoField ? infoField.getInputField() : null;
    var $elt = opts.elt || null;

    // Allow input in opts to override attempt to getInputField(). Used
    // you already have a non-infofield <input> to attach to
    var $input = opts.input || null;
    if (!$input) {
      $input = infoField ? infoField.getInputField() : null;
    }

    if (!$input && $elt) {
        $input = $('<input>'); // XSS OK -KF
        $input.insertAfter($elt).width(0).prop('disabled', true);
    }

    if (!$input) { return; }

    $input.datepicker({ buttonImage: '/static/images/calendar_16x15.png',
                       buttonImageOnly : true,
                       showOn: 'button',
                       onSelect: function(var_args) {
                           if (infoField) {
                            infoField.setVal(infoField.getVal());
                            $input.change();
                          }
                           if (dateSelectedFn) { dateSelectedFn.apply(this, arguments); }
                       },
                       onClose: closeFn,
                       maxDate: opts.maxDate || null,
                       minDate: opts.minDate || el8.util.consts.MIN_DATE,
                       defaultDate: defaultDate,
                       constrainInput : false
                     });

    if (infoField) {
        $input.blur(function() {
            if (!infoField.noInput()) {
                var dateVal = el8.util.datecompare.processDateInput(infoField.getVal(), null, el8.uiwidget.alert);
                infoField.setVal(dateVal ? dateVal.asString() : '');
                $input.trigger('focusout'); // re-runs validation (if present)
                //if (dateSelectedFn) { dateSelectedFn.apply(this, arguments); }
                if (dateSelectedFn) { dateSelectedFn.apply(this, [dateVal ? dateVal.asString() : '']); }
            }
        });
    }
    $input.on('click', function() {
        $input.datepicker("hide");
    // Overridding browser's autocomplete for previous entries
    }).attr('autocomplete', 'off');

    return $input;

};
